<template>
  <div class="createOrder-page full-height">
    <table-con>
      <!-- 面包屑 -->
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders/orderList' }">{{ $t('laund.laund1') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('defe.defe1') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 搜索框 -->
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">NO:</div>
              <div class="flex1">
                <el-input :placeholder="$t('defe.defe2')" clearable v-model="queryInfo.orderNo" size="small"
                  @keyup.enter.native="searchList"></el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">{{ $t('defe.defe3') }}</div>
              <div class="flex1">
                <el-date-picker style="width:60px" v-model="queryInfo.createTimeStart" type="date" size="small"
                  :placeholder="$t('defe.defe4')">
                </el-date-picker>
                <p>~</p>
                <el-date-picker style="width:60px" v-model="queryInfo.createTimeEnd" type="date" size="small"
                  :placeholder="$t('defe.defe4')">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">{{ $t('defe.defe5') }}</div>
              <div class="flex1">
                <el-date-picker style="width:60px" v-model="queryInfo.handleTimeStart" type="date" size="small"
                  :placeholder="$t('defe.defe4')">
                </el-date-picker>
                <p>~</p>
                <el-date-picker style="width:60px" v-model="queryInfo.handleTimeEnd" type="date" size="small"
                  :placeholder="$t('defe.defe4')">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">{{ $t('defe.defe6') }}</div>
              <div class="flex1">
                <el-select v-model="queryInfo.handleType" :placeholder="$t('goods.goods21')" size="small" clearable>
                  <el-option v-for="(item,index) in defectiveWayOptions" :key="index" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title" style="width:150px">{{ $t('defe.defe7') }}</div>
              <div class="flex1">
                <el-input :placeholder="$t('defe.defe9')" clearable v-model="queryInfo.waybillNumber"
                  size="small"></el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title" style="width:200px">{{ $t('defe.defe8') }}</div>
              <div class="flex1">
                <el-input :placeholder="$t('defe.defe9')" clearable v-model="queryInfo.returnWaybillNo"
                  size="small"></el-input>
              </div>
            </el-col>
          </el-row>
        </el-collapse>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 0 }"
              @click="quickSearchList('', index = 0)">{{ $t('defe.defe10') }}</el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 1 }"
              @click="quickSearchList('1', index = 1)">{{ $t('defe.defe11') }}<span class="lx-red">({{ orderData.waitNum
              }})</span>
            </el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 2 }"
              @click="quickSearchList('2', index = 2)">{{ $t('defe.defe12') }}<span class="lx-red">({{
                orderData.handlingNum }})</span>
            </el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 3 }"
              @click="quickSearchList('3', index = 3)">{{ $t('defe.defe13') }}</el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 4 }"
              @click="quickSearchList('4', index = 4)">{{ $t('defe.defe14') }}</el-button>
          </el-col>
          <el-col :span="18" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-blue" @click="batchExportAction">{{ $t('export') }}</el-button>
              <el-button class="search-btn btn-gray" @click="clearAll">{{ $t('defe.defe15') }}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{ $t('defe.defe16') }}</el-button>
              <el-button class="search-btn btn-green" @click="toSort">{{ $t('orderList.orderList156') }}</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt=""
                @click="isActive = !isActive">{{ $t('search.expandPanel') }}</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt=""
                @click="isActive = !isActive">{{ $t('search.retractPanel') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 表格 -->
      <div slot="table" class="lx-table-wrapper lx-flex-grow-1 lx-hidden lx-relative">
        <lx-table :list="tableData" isSelectTable border stripe :rowKey="'id'" :emptyText="$t('select.select24')"
          :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" @selectionChange="handleSelectionChange">
          <el-table-column v-for="(item, index) in asyncColumns" :key="index" align="center" :label="item.name"
            :prop="item.key" :width="item.width ? item.width : 'auto'"
            :min-width="item.minWidth ? item.minWidth : 'auto'">
            <template v-slot="scope">
              <div v-if="item.key === 'handle'">
                <el-button class="list-btn btn-blue" @click="toDefectiveDetail(scope.row)">{{ $t('defe.defe18')
                }}</el-button>
              </div>
              <div v-else-if="item.key === 'handleWay'">
                  <div v-if="scope.row.handleState=='1' && scope.row.cusHandleType == null">
                      <el-button class="list-btn btn-green" @click="cusHandleWay(scope.row,1)">{{$t('defe.defe101')}}</el-button>
                      <el-button class="list-btn btn-deepblue" @click="cusHandleWay(scope.row,2)">{{$t('defe.defe102')}}</el-button>
                      <el-button class="list-btn btn-blue" @click="cusHandleWay(scope.row , 3)">{{$t('defe.defe103')}}</el-button>

                  </div>
                <!-- <div v-if="scope.row.handleState=='1'">
                  <div class="btn-row">
                    <el-button class="list-btn btn-green" @click="moreDefective(scope.row,1)">{{$t('defe.defe19')}}</el-button>
                  </div>
                  <el-button class="list-btn btn-green" @click="moreDefective(scope.row,2)">{{$t('defe.defe20')}}</el-button>
                  <el-button class="list-btn btn-deepblue" @click="moreDefective(scope.row,3)">{{$t('defe.defe21')}}</el-button>
                  <el-button class="list-btn btn-deepblue" @click="moreDefective(scope.row,4)">{{$t('defe.defe22')}}</el-button>
                  <el-button class="list-btn btn-blue" @click="moreDefective(scope.row,5)">{{$t('defe.defe23')}}</el-button>
                  <el-button class="list-btn btn-blue" @click="moreDefective(scope.row,6)">{{$t('defe.defe24')}}</el-button>
                  <el-button class="list-btn btn-green" @click="moreDefective(scope.row,7)">{{$t('defe.defe25')}}</el-button>
                </div> -->
                <div v-for="(item, index1) in defectiveWayOptions" :key="index + '-' + index1">
                  <div v-if="item.value == scope.row.handleType && scope.row.handleState != '1'">
                    {{ item.label }}
                  </div>
                </div>

                  <div v-for="(item, index) in cusDefectiveWayOptions" :key="index">
                      <div v-if="item.value == scope.row.cusHandleType ">
                          {{$t('defe.defe104')}} {{ item.label }}
                      </div>
                  </div>

              </div>
              <div v-else-if="item.key === 'badNo'">
                {{ scope.row.id }}
              </div>
              <div v-else-if="item.key === 'createTime'">
                {{ scope.row.createTime | dateFormatToSecond }}
              </div>
              <div v-else-if="item.key === 'no'">
                {{ scope.row.orderNo }}
              </div>
              <div v-else-if="item.key === 'count'">
                {{ scope.row.count }}
              </div>
              <div v-else-if="item.key === 'pictureUrl1'">
                <img @click="imgclick(scope.row.pictureUrl, true)"
                  v-if="scope.row.pictureUrl && scope.row.pictureUrl.length > 0"
                  :src="scope.row.pictureUrl + commonData.smallimg" alt="" class="list-image">
                <img v-else src="../../assets/images/default.png" alt="" class="list-image">
                <el-button class="list-btn-four btn-blue" @click="toGoodsDetail(scope.row)">
                  {{ $t('defe.defe26') }}
                </el-button>
              </div>
              <div v-else-if="item.key === 'badPicture'">
                <div class="imgBox">
                  <div class="img">
                    <img @click="imgclick(scope.row.problemUrl1, true)"
                      v-if="scope.row.problemUrl1 && scope.row.problemUrl1.length > 0"
                      :src="scope.row.problemUrl1 + commonData.smallimg" alt="" class="list-image">
                    <img v-else src="../../assets/images/default.png" alt="" class="list-image">
                  </div>
                  <div class="img">
                    <img @click="imgclick(scope.row.problemUrl2, true)"
                      v-if="scope.row.problemUrl2 && scope.row.problemUrl2.length > 0"
                      :src="scope.row.problemUrl2 + commonData.smallimg" alt="" class="list-image">
                    <img v-else src="../../assets/images/default.png" alt="" class="list-image">
                  </div>
                  <div class="img">
                    <img @click="imgclick(scope.row.problemUrl3, true)"
                      v-if="scope.row.problemUrl3 && scope.row.problemUrl3.length > 0"
                      :src="scope.row.problemUrl3 + commonData.smallimg" alt="" class="list-image">
                    <img v-else src="../../assets/images/default.png" alt="" class="list-image">
                  </div>
                </div>
              </div>
              <div v-else-if="item.key === 'badSituation'">
                {{ scope.row.badSituation }}
              </div>
              <div v-else-if="item.key === 'badCount'">
                <div>
                  <span class="table-cell-title-mid">{{ $t('defe.defe27') }}</span>
                  <span>{{ scope.row.brokenCount }}</span>
                </div>
                <div>
                  <span class="table-cell-title-mid">{{ $t('defe.defe28') }}</span>
                  <span>{{ scope.row.dirtCount }}</span>
                </div>
                <div>
                  <span class="table-cell-title-mid">{{ $t('defe.defe29') }}</span>
                  <span>{{ scope.row.designCount }}</span>
                </div>
                <div>
                  <span class="table-cell-title-mid">{{ $t('defe.defe30') }}</span>
                  <span>{{ scope.row.insufficientCount }}</span>
                </div>
              </div>
              <div v-else-if="item.key === 'badDesc'">
                {{ scope.row.badDescription }}
              </div>
              <!-- language === 'zh' ?scope.row.handleDescription : scope.row.handleDescrintionJp -->
              <div v-else-if="item.key === 'handleDesc'">
                <div class="commentDetail">
                  <p style="font-size: 14px!important;max-height: 100px;overflow-y: auto">
                    {{ scope.row.handleDescription | objLang(scope.row.handleDescriptionJp) }}
                  </p>
                  <p style="font-size: 14px!important;">{{ scope.row.handleTime | dateFormatToSecond }}</p>

                </div>
                <div class="btn-row">
                  <el-button class="list-btn btn-blue" @click="defectiveAll(scope.row)">{{ $t('defe.defe10')
                  }}</el-button>
                  <el-button class="list-btn btn-blue" @click="addDefective(scope.row)">{{ $t('defe.defe31')
                  }}</el-button>
                </div>
              </div>
              <div v-else-if="item.key === 'handleStatus'">
                {{ scope.row.handleState == '1' ? $t('defe.defe11') :
                  scope.row.handleState == '2' ? $t('defe.defe12') : scope.row.handleState == '3' ? $t('defe.defe13') :
                    $t('defe.defe14')
                }}
              </div>
              <div v-else-if="item.key === 'handleTime'">
                {{ scope.row.handleTime | dateFormatToSecond }}
              </div>
              <div v-else-if="item.key === 'returnWaybillNo'">
                <el-input v-model="scope.row.returnWaybillNo" size="mini" @blur="updateNotes(scope.row, 1)" />
              </div>
              <div v-else-if="item.key === 'waybillNumber'">
                <el-input v-model="scope.row.waybillNumber" size="mini" @blur="updateNotes(scope.row, 2)" />
              </div>
              <div v-else-if="item.key === 'returnAddress'">
                <el-input v-model="scope.row.returnAddress" size="mini" @blur="updateNotes(scope.row, 3)" />
              </div>
              <!--不良品视频-->
              <div v-else-if="item.key === 'problemVideo'">
                <div v-if="scope.row.problemVideoUrl1">
                  <el-button class="list-btn btn-green"
                             @click="handlePlayVideo(scope.row.problemVideoUrl1)">{{$t('OrderBill.OrderBill22')}}1</el-button>
                </div>
                <div v-if="scope.row.problemVideoUrl2">
                  <el-button class="list-btn btn-green"
                             @click="handlePlayVideo(scope.row.problemVideoUrl2)">{{$t('OrderBill.OrderBill22')}}2</el-button>
                </div>
                <div v-if="scope.row.problemVideoUrl3">
                  <el-button class="list-btn btn-green"
                             @click="handlePlayVideo(scope.row.problemVideoUrl3)">{{$t('OrderBill.OrderBill22')}}3</el-button>
                </div>
              </div>

            </template>
          </el-table-column>
        </lx-table>
        <el-pagination class="lx-page-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum" :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </table-con>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
    <!-- 处理方式 -->
    <el-dialog @close="cancel('replyInfo')" :title="replyInfos.tips" width="600px" center
      :visible.sync="replyInfos.dialogVisible">
      <div class="form">
        <p>{{ replyInfos.comment }}</p>
      </div>
      <el-form :model="replyInfos" :rules="rules" ref="replyInfo" label-width="125px" class="demo-replyInfo">
        <div style="display: none">
          <el-form-item label="id：" prop="id">
            <el-input v-model="replyInfos.id" size="small" style="width: 90%" :disabled="true"></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 1">
          <el-form-item :label="$t('defe.defe32')" prop="exchangeCount">
            <el-input v-model="replyInfos.exchangeCount" size="small" style="width: 90%"></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 3">
          <el-form-item :label="$t('defe.defe33')" prop="returnCount">
            <el-input v-model="replyInfos.returnCount" size="small" style="width: 90%"></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 4">
          <el-form-item :label="$t('defe.defe34')" prop="returnCount">
            <el-input v-model="replyInfos.returnCount" size="small" style="width: 90%" :disabled="true"></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 2">
          <el-form-item :label="$t('defe.defe35')" prop="reissueCount">
            <el-input v-model="replyInfos.reissueCount" type="number" size="small" style="width: 90%"></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 1 || handleflag == 2">
          <el-form-item :label="$t('defe.defe36')" prop="waybillNumber">
            <el-input v-model="replyInfos.waybillNumber" size="small" style="width: 90%"></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 5">
          <el-form-item :label="$t('defe.defe37')" prop="destroyCount">
            <el-input v-model="replyInfos.destroyCount" size="small" style="width: 90%"></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 6">
          <el-form-item :label="$t('defe.defe38')" prop="destroyCount">
            <el-input v-model="replyInfos.destroyCount" size="small" style="width: 90%" :disabled="true"></el-input>
          </el-form-item>
        </div>
        <div v-if="handleflag == 1 || handleflag == 3 || handleflag == 4">
          <el-form-item :label="$t('defe.defe39')" prop="returnAddress">
            <el-input v-model="replyInfos.returnAddress" size="small" style="width: 90%"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('replyInfo')">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="saveMode('replyInfo')">{{ $t('submit') }}</el-button>
      </div>
    </el-dialog>
    <!-- 处理说明 -->
    <el-dialog :title="$t('defe.defe40')" width="800px" center :visible.sync="dialogVisible">
      <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="items" border
        height="450px">
        <el-table-column type="index" align="center" :label="$t('defe.defe41')" width="60"></el-table-column>\
        <el-table-column align="center" prop="createUserRealName" :label="$t('defe.defe42')" width="120">
          <template v-slot="scope">
            {{ scope.row.createUserRealName }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="createTime" width="120" :label="$t('defe.defe43')">
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="content" :label="$t('defe.defe44')">
          <template v-slot="scope">
            {{ scope.row.content | objLang(scope.row.contentJp) }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('defe.defe45') }}</el-button>
      </div>
    </el-dialog>
    <!-- 添加说明 -->
    <el-dialog :title="$t('defe.defe46')" width="600px" center @close="cancel('replyInfo')" :visible.sync="addVisible">
      <el-form :model="handle" :rules="rules" ref="replyInfo" label-width="150px" class="demo-replyInfo">
        <div class="inputBox">
          <el-form-item prop="content" :label="$t('defe.defe40')">
            <el-input type="textarea" resize="none" :rows="3" v-model="handle.content"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('replyInfo')">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="saveExplain('replyInfo')">{{ $t('submit') }}</el-button>
      </div>
    </el-dialog>
    <lx-sort :visible.sync="isVisibleSort" :list="columns" @confirm="doSaveColumns"></lx-sort>

  </div>
</template>

<script>
import { columns as originColumns } from "./columns";
import LxTable from '@/components/LxTable'
import { filterList } from "@/assets/js/utils";
import LxSort from "@/components/LxSort/index";
import tableCon from "../../views/tableContainer";
import { mapGetters } from 'vuex'
export default {
  components: {
    LxTable,
    LxSort,
    tableCon,
  },
  data() {
    return {
      isActive: false,
      curIndex: 0, // 默认选中第0个
      isLoading: true,
      isVisibleSort: false,
      originColumns, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      menuSettingData: {
        menuId: 'Defective'
      },
      tableData: [],
      handleflag: 1,
      queryInfo: {
        pageSize: 10,
        pageNum: 1,
        handleType: '',
        handleState: ''
      },
      orderData: {
        waitNum: 0
      },
      defectiveWayOptions: [
        { value: '1', label: this.$t('defe.defe19') },
        { value: '2', label: this.$t('defe.defe20') },
        { value: '3', label: this.$t('defe.defe21') },
        { value: '4', label: this.$t('defe.defe22') },
        { value: '5', label: this.$t('defe.defe23') },
        { value: '6', label: this.$t('defe.defe24') },
        { value: '7', label: this.$t('defe.defe25') },
      ],
      defectiveStatusOptions: [
        { value: '', label: this.$t('defe.defe10') },
        { value: '1', label: this.$t('defe.defe11') },
        { value: '2', label: this.$t('defe.defe12') },
        { value: '3', label: this.$t('defe.defe13') },
        { value: '4', label: this.$t('defe.defe14') },
      ],

      cusDefectiveWayOptions: [
            { value: '1', label: this.$t('defe.defe101') },
            { value: '2', label: this.$t('defe.defe102') },
            { value: '3', label: this.$t('defe.defe103') },
      ] ,

      defectiveWayOption: [],
      imgurl: '',
      visible: false,
      //控制弹窗为哪一种
      replyInfos: {
        //弹窗控制
        dialogVisible: false,
      },
      rules: {
        exchangeCount: [
          { required: true, message: this.$t('defe.defe47'), trigger: 'blur' }
        ],
        reissueCount: [
          { required: true, message: this.$t('defe.defe48'), trigger: 'blur' }
        ],
        returnCount: [
          { required: true, message: this.$t('defe.defe49'), trigger: 'blur' }
        ],
        destroyCount: [
          { required: true, message: this.$t('defe.defe50'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: this.$t('defe.defe51'), trigger: 'blur' }
        ]
      },
      // 说明
      dialogVisible: false,
      //添加说明
      addVisible: false,
      handle: {},
      total: 1,
      items: [],
      sendInfos: {
        id: '',
        orderNo: ''
      },
      multipleSelection:[],
    }
  },
  computed: {
    ...mapGetters([
      'language',
    ])
  },
  methods: {
    // 获取已选择列
    getAsyncColumns() {
      return new Promise((resolve) => {
        this.$http.get("menu/menuSetting", {
          params: {
            menuId: 'Defective'
          }
        }).then((res) => {
          var result = [];
          if (res.data.code === 200) {
            var record = res.data.data;
            this.menuSettingData = record;
            result = JSON.parse(record.menuSetting);
          }
          if (result && result.length > 0) {
            result.forEach((item) => {
              this.$set(item, "isShow", true);
            });
            let noSelectList = filterList(
              this.originColumns,
              result,
              "columnId"
            );
            this.columns = result.concat(noSelectList);
            this.asyncColumns = result;
            resolve();
            console.log(this.asyncColumns)
          } else {
            this.columns = this.originColumns;
            this.columns.forEach((item) => {
              this.$set(item, "isShow", true);
            });
            this.asyncColumns = this.columns;
            resolve();
            console.log(this.asyncColumns)
          }
        });
      });
    },
    // 保存选择的列
    doSaveColumns(list) {
      var my = this;
      var url = "menu/updateMenuSetting";
      this.menuSettingData.menuSetting = JSON.stringify(list);
      this.$http.post(url, this.menuSettingData).then((res) => {
        if (res.data.code === 200) {
          this.isVisibleSort = false;
          my.$message({
            type: "success",
            message: this.$t('defe.defe52'),
          });
          this.queryInfo.pageNum = 1;
          this.getAsyncColumns().then(() => {
            this.getDefectiveList();
          });
        } else {
          my.$message({
            type: "warning",
            message: this.$t('defe.defe53'),
          });
        }
      });
    },
    // 排序
    toSort() {
      this.isVisibleSort = true;
    },
    toGoodsDetail(row) {
      window.open(row.taobaoUrl, '_blank')
    },
    async updateNotes(row, flag) {      //表格修改内容
      row.type = flag;
      console.log(row);
      var _this = this;
      var url = 'problem/updateWaybillNo';
      const { data: res } = await _this.$http.post(url, row);
      if (res.code == 200) {
        _this.$message({
          type: 'success',
          message: res.message
        }),
          _this.replyDialogVisible = false;
        _this.getDefectiveList();
        _this.getStatisticalNum();
      } else {
        _this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    saveExplain(formName) {                      //保存说明
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('problem/saveHandleLog', this.handle).then(res => {
            if (res.data.code == 200) {
              this.$message({
                type: 'success',
                message: res.data.message
              })
              this.problemData = {};
              this.addVisible = false;
              this.getDefectiveList();
              this.getStatisticalNum();
            } else {
              this.$message({
                type: 'warning',
                message: res.data.message
              })
            }
          })
        } else {
          this.$message.error(this.$t('defe.defe54'));
          return false;
        }
      });
    },
    handleCurrentChange(newPage) {    //分页
      this.queryInfo.pageNum = newPage;
      this.getDefectiveList();
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getDefectiveList();
    },
    cancel(formName) {                 //取消
      this.$refs[formName].clearValidate();
      this.replyInfos.dialogVisible = false;
      this.addVisible = false;
    },
    saveMode(formName) {             //保存
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.handleflag)
          if (this.handleFlag == 7) {
            this.sendDeal(this.handleflag);
          } else {
            this.handleDeal(this.handleflag);
          }
        } else {
          this.$message.error(this.$t('defe.defe54'));
          return false;
        }
      });
    },
    async sendDeal(flag) {    //正常发送
      var _this = this;
      _this.sendInfos.handleType = flag;
      var url = 'problem/sendNormally';
      const { data: res } = await _this.$http.post(url, _this.sendInfos);
      if (res.code == 200) {
        _this.$message({
          type: 'success',
          message: res.message
        }),
          _this.replyInfos.dialogVisible = false;
        _this.getDefectiveList();
        _this.getStatisticalNum();
      } else {
        _this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    async handleDeal(handleFlag) {    //处理不良件
      var _this = this;
      _this.replyInfos.handleType = handleFlag;
      var url = 'problem/handleProblem';
      const { data: res } = await _this.$http.post(url, _this.replyInfos);
      if (res.code == 200) {
        _this.$message({
          type: 'success',
          message: res.message
        }),
          _this.replyInfos.dialogVisible = false;
        _this.getDefectiveList();
        _this.getStatisticalNum();
      } else {
        _this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    defectiveAll(data) {         //全部
      console.log(data)
      this.$http.get('problem/handleLogList', { params: { id: data.id } }).then(res => {
        console.log(res)
        this.items = res.data.data.reverse();
      })
      this.dialogVisible = true;
    },
    addDefective(data) {             //添加
      console.log(data)
      console.log(data.id)
      this.addVisible = true;
      this.handle.problemId = data.id;
    },
      cusHandleWay(row, flag) {
          return new Promise(() => {
              this.$http.get("problem/saveCusHandleWay", {
                  params: {
                      id: row.id,
                      cusHandleType: flag
                  }
              }).then(() => {
                  this.getDefectiveList();
                  this.getStatisticalNum();
              });
          });
      } ,
    moreDefective(row, flag) {      //处理方式
      this.handleflag = flag;
      this.replyInfos = {
        id: '',
        exchangeCount: '',
        returnFee: '0',
        waybillNumber: '',
        reissueCount: '',
        returnCount: '',
        destroyCount: '',
        dialogVisible: true,
      };
      if (flag == 1) {
        this.replyInfos.tips = this.$t('defe.defe55');
        this.replyInfos.comment = this.$t('defe.defe56');
        this.replyInfos.waybillNumber = row.waybillNumber;
        this.replyInfos.exchangeCount = row.count;
      } else if (flag == 2) {
        this.replyInfos.comment = this.$t('defe.defe57');
        this.replyInfos.tips = this.$t('defe.defe58');
        this.replyInfos.waybillNumber = row.waybillNumber;
        this.replyInfos.reissueCount = row.count;
      } else if (flag == 3) {
        this.replyInfos.comment = this.$t('defe.defe59');
        this.replyInfos.tips = this.$t('defe.defe60');
      } else if (flag == 5) {
        this.replyInfos.tips = this.$t('defe.defe61');
      }
      if (flag == 4) {
        this.replyInfos.comment = this.$t('defe.defe62');
        this.replyInfos.returnCount = row.count;
        this.replyInfos.tips = this.$t('defe.defe63');
      } else if (flag == 6) {
        this.replyInfos.destroyCount = row.count;
        this.replyInfos.tips = this.$t('defe.defe64');
      } else if (flag == 7) {
        this.replyInfos.tips = this.$t('defe.defe65');
        this.replyInfos.dialogVisible = true;
        this.replyInfos.comment = this.$t('defe.defe66');
        this.sendInfos.id = row.id;
        this.sendInfos.orderNo = row.orderNo;
      }
      this.replyInfos.id = row.id;
    },
    searchList() {         //搜索
      console.log(this.queryInfo)
      this.getDefectiveList();
      this.getStatisticalNum();
    },
    quickSearchList(val, index) {
      this.curIndex = index
      this.queryInfo.pageNum = 1;
      this.queryInfo.handleState = val;
      this.getDefectiveList();
      this.getStatisticalNum();
    },
    clearAll() {           //清空
      console.log("clear")
      this.queryInfo = {
        pageSize: 10,
        pageNum: 1,
        handleType: '',
        handleState: ''
      };
    },
    async getDefectiveList() {      //获取
      const { data: res } = await this.$http.get("problem/list", { params: this.queryInfo });
      this.tableData = res.data.list;
      this.total = res.data.total;
    },
    async getStatisticalNum() {      //获取
      const { data: res } = await this.$http.get("problem/getStatisticalNum", { params: this.queryInfo });
      console.log(res.data)
      this.orderData = res.data;
    },
    toDefectiveDetail(data) {    //跳转详情
      this.$router.push({
        name: 'defectiveDetail',
        query: {
          id: data.id
        }
      })
    },
    imgclick(url, visible) {
      this.visible = true
      this.imgurl = url
    },
    // async exportAction() {
    //   this.$http({
    //     url: 'problem/exportAction',
    //     method: 'get',
    //     params: this.queryInfo,
    //     responseType: 'blob', // 表明返回服务器返回的数据类型
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     data: {
    //       //接口参数
    //     }
    //   }).then((res) => {
    //     //创建一个隐藏的a连接，
    //     const link = document.createElement('a');
    //     let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
    //     link.style.display = 'none';
    //     //设置连接
    //     link.href = URL.createObjectURL(blob);
    //     link.download = '不良件货库.xlsx';
    //     document.body.appendChild(link);
    //     //模拟点击事件
    //     link.click();
    //   }).catch((err) => {
    //     // console.log(err);
    //   })
    // },
    async batchExportAction() {
      const idList = this.multipleSelection.map(item => item.id)
      this.$http({
        url: 'problem/batchExportAction',
        method: 'post',
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
          idList:idList
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '不良件货库.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        // console.log(err);
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //播放视频
    handlePlayVideo(param){
      window.open(param,'_blank');
    },
  },
  created() {
    if (this.$route.query.orderid) {
      this.queryInfo.orderNo = this.$route.query.orderid
    }
    this.getStatisticalNum();
    this.getAsyncColumns().then(() => {
      this.getDefectiveList();
    })

  }
}
</script>

<style scoped>
.flex1 {
  display: flex;
}

.flex1 p {
  font-size: 20px;
}

.form {
  width: 100%;
  padding: 20px;
}

.form p {
  font-size: 16px;
}

.commentDetail {
  margin-bottom: 20px;
}

.imgBox {
  display: flex;
}

.imgBox .img {
  margin-right: 10px;
}

.lx-table-wrapper {
  padding-bottom: 43px;
  box-sizing: content-box;
}

.lx-page-pagination {
  position: absolute;
  right: 0;
  bottom: 5px;
  width: 100%;
  height: 35px;
  background-color: #fff;
}
</style>
